import {CircularProgress} from "@mui/material";

export default function MaiaCircularProgress() {
  return (
    <CircularProgress/>
  );
}